/**************************************************
 * Nombre:       Formulario_Producto_Inventario
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AllInboxOutlined, Inventory, TrendingDown, TrendingUp} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";

const Formulario_Producto_Inventario = ({...props}) => {
    const [categorias, setCategorias] = useState([])
    const [zonas, setZonas] = useState([])

    useEffect(() => {
        obtenerCol('categorias').then((categorias) => {
            setCategorias(categorias.data)
        })
        obtenerCol('zonas').then((zon) => {
            setZonas(zon.data)
        })
    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoTexto Icono={Inventory} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


                <Grid container size={6}>
                    <IngresoTexto Icono={AllInboxOutlined} nombre={'Num Existencias'} dato={'existencias'} {...props}
                                  requerido={'Campo requerido'} type={'number'}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>

                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={TrendingDown} nombre={'Num Minimo'} dato={'minimo'} {...props}
                                  requerido={'Campo requerido'} type={'number'}
                    />
                </Grid>
                <Grid container size={6}>
                    <IngresoTexto Icono={TrendingUp} nombre={'Num Maximo'} dato={'maximo'} {...props}
                                  requerido={'Campo requerido'} type={'number'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto_Inventario